import Login from './Reset';

export default Login;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Reset/index.ts